<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { useApiTokensApi } from '../../api/api-tokens/list.hook'
import TableApiTokens from './TableApiTokens.vue'
import ModalCreateApiToken from './modals/ModalCreateApiToken.vue'
import ModalEditApiToken from './modals/ModalEditApiToken.vue'
import ModalDeleteApiToken from './modals/ModalDeleteApiToken.vue'

defineOptions({
  name: 'ApiTokensPage',
})

onMounted(() => {
  void useApiTokensApi()
})

useOnTimezoneChange(() => {
  void useApiTokensApi()
})
</script>

<template>
  <TableApiTokens />
  <ModalCreateApiToken />
  <ModalEditApiToken />
  <ModalDeleteApiToken />
</template>
